<template>
    <main class="ForgotPassword">
        <v-alert v-if="showAlert" class="ForgotPassword_alert" :type="alertType" :dismissible="false">{{ alertMessage }}</v-alert>
        <v-card class="ForgotPassword_card">
            <div class="ForgotPassword_box">
                <div class="d-flex justify-end mb-3">
                    <img src="@/assets/img/logo-login1.svg" alt="logo">
                </div>
                <form class="ForgotPassword_form" @submit.prevent="processRecovery()">
                    <div class="text-h4 mb-3">Forgot Password</div>
                    <div class="ForgotPassword_field">
                        <label class="hidden">Email</label>
                        <input name="email" type="email" placeholder="Email" v-model="email">
                    </div>
                    <div class="ForgotPassword_submit">
                        <v-btn color="primary" type="submit">Get Password</v-btn>
                    </div>
                </form>
                <v-overlay :value="overlay">
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
                <v-alert v-if="showError" :icon="false" dense class="mt-5" id="error" type="error">{{ messageAlert }}</v-alert>
            </div>
        </v-card>
    </main>
</template>

<script>
import { RouterLink } from 'vue-router';
import {  mapActions } from "vuex";
import { BUS_EVENTS } from '@/constants';
import { EventBus } from '@/utilities';

export default {
    name: "ForgotPassword",
    data() {
        return {
            email : '',
            showError: false,
            messageAlert:'',
            showAlert: false,
            overlay: false,
            environment: process.env.NODE_ENV,
        };
    },
    beforeMount(){
        EventBus.$on(BUS_EVENTS.ALERT_TRIGGERED, this.setShowAlert);
    },
    components: { RouterLink },
    methods:{
        ...mapActions(["processRecoveryFn"]),
        async processRecovery(){
            const user = new FormData();
            user.append('email_forgot',this.email);
            user.append('environment',this.environment);
            this.overlay = !this.overlay
            try {
                const response  = await this.processRecoveryFn(user),
                      data      = response.data.data;

                if(data.result == 'error'){
                    this.messageAlert = data.errorProcessRecovery;
                    this.showError = true
                }else{
                    EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED , { type: 'success', message: 'Thank you for your request. Please check your email to complete the process.', duration: 2e3, });
                    this.email = '';
                    this.showError = false
                }
                this.overlay   = false;
            } catch (error) {
                EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED , { type: 'error', message: error.message, duration: 2e3, });
                this.showError = false
                setTimeout(()=>{this.overlay = false;},2000)
            }
        },
        setShowAlert (ops) {
            this.alertType = ops.type || 'info';
            this.alertMessage = ops.message || '...';
            this.showAlert = true;
            setTimeout(() => this.showAlert = false, ops.duration || 1e3);
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/scss/colors.scss";
    .ForgotPassword{
        background: $purple;
        display: grid;
        place-items: center;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 20px;
        &_card{
            width: 100%;
            max-width: 900px;
            padding: 70px 30px;
        }
        &_box{
            display: block;
            width: 100%;
            max-width: 700px;
            margin: auto;
        }
        .text{
            color: #767676;
            font-size: 19px;
        }
        &_field{
            display: block;
            margin-bottom: 20px;
            position: relative;
            label{
                width: 0;
                height: 0;
                visibility: hidden;
                position: absolute;
                opacity: 0;
            }
            input{
                display: block;
                width: 100%;
                max-width: 350px;
                height: 35px;
                padding: 0 20px;
                border: 1px solid #BFBFBF;
                border-radius: 4px;
                &::placeholder{
                    color: #BFBFBF;
                }
            }
        }
        .small{
            color: #767676;
            font-size: 13px;
        }
        &_submit{
            display: block;
            margin-top: 30px;
            .v-btn{
                min-width: 180px;
            }
        }
    }

    #app .ForgotPassword .text-h4{
        font: 300 34px 'Spectral', serif !important;
        color: $purple;
        letter-spacing: -0.03em !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue